import React from "react";
import ImageComponent from "../../../../components/common/ImageComponent";
import OTPInput from "./OtpForm";
import BjsImage from '../../../../images/bjsLogoWhiteBG.png'
import { Carousel } from "antd";  
import styles from "./otpForm.module.css"

const OtpLoginPage = () => {
return<>
    <div className="main-container">

    <div className="login-field animate__animated">
        <div className="loginimages">
          <div className="login-orange"></div>
          <div className="login-darkblue"></div>
          <div className="login-blue"></div>
          <div className="login-green"></div>
          <div className="login-yellow"></div>
        </div>
        
        <div className="logo">
          <img src={BjsImage} alt="BJS image." width="200px"/>
        </div>
      
        <div className="text">
          <h2>Enter OTP</h2>  
        </div>
        
        <div>
          <form className="input_n_btns">
            <OTPInput/>          
          </form>
        </div>
      {/* <div className={styles.otpfield}>

        <div className={styles.logo}>
          <img src={BjsImage} alt="BJS image." width="200px"/>
        </div>      

        <div className={styles.otptext}>
          <h2>Enter OTP</h2>  
        </div>      

        <div className={styles.otpip}>
          <form>
            <OTPInput />
          </form>
        </div> */}
      </div>

      
    </div>
</>
}
export default OtpLoginPage


// ORIGINAL CODE V


// const OtpLoginPage = () => {
//   return (
//     <>
//       <div className="container">
//         <div className="form-box form-padding">
//           <div className="login-bg">
//             <div className="box-corner">
//                 <div></div>
//                 <div></div>
//             </div>
//             <div className="box-corner">
//                 <div></div>
//                 <div></div>
//             </div>
//             <div className="overlay"></div>
//             <div className="header-form">
//               <h4 className="text-primary text-center">
//                 <i className="fa fa-user-circle" style={{ fontSize: "40px" }}>
//                   Login
//                 </i>
//               </h4>
//               <div className="imageLogo">
//                 {/* <img src={BjsImage} alt="BJS image." width="200px" borderR/>  */}
//                 <ImageComponent
//                   src={BjsImage}
//                   alt="BJS image."
//                   width="200px"
//                   height="auto" // You can set this to a specific height if needed
//                   borderRadius="10px" // Example border radius
//                   className="my-custom-class" // Optional: add any additional classes
//                 />
//               </div>
//             </div>
//             <div className="body-form">
//               <form>
//                 <OTPInput />
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default OtpLoginPage;
